import TarafKisi from "./parser/TarafKisi";
import TarafKurum from "./parser/TarafKurum";

/**
 * DEV-4317: Takip hazırla ekranında tiki kaldırılan taraf UYAP'a gitmemeli.
 *
 * Ekrandaki tik `selected` alanına bağlı. `takipeDahilEt` ise sorgu sonucudur (ölü / hatalı
 * TC'li borçlu false olur, tiki de kilitlenir). Alacaklılarda yalnız tik geçerlidir; alacaklı
 * sorun kaydı takip açmayı zaten engeller.
 */
export function tarafTakibeDahilMi(taraf: TarafKisi | TarafKurum): boolean {
    // Rolü okunamayan taraf UYAP'a zaten gönderilemez (kuyruk akışı da eskiden bunu çıkarıyordu).
    if (!taraf || !taraf.tarafSifati)
        return false;
    if (taraf.selected === false)
        return false;
    if (!taraf.isAlacakli() && taraf.takipeDahilEt === false)
        return false;
    return true;
}

/**
 * Alacak kalemleri tarafları listedeki sıralarıyla gösterir. Listeden taraf çıkınca kalan
 * tarafların sırası kayar; kalemin sıraları yeni listeye göre yeniden yazılmazsa kalem
 * yanlış tarafa bağlanır. Çıkarılan tarafın sırası düşer (`yeniSira[eski] = -1`).
 */
export function yeniSiralariHesapla(siralar: Array<string | number>, yeniSira: number[]): number[] {
    return siralar
        .map(sira => yeniSira[Number(String(sira).trim())])
        .filter(sira => typeof sira == "number" && sira >= 0);
}

/** Kalemi taşıyan tarafların hepsi çıkarıldıysa kalem UYAP'a tarafsız gider; bunu durdurmak için. */
export function tarafsizKalemHatasi(kalemAdlari: string[]): Error {
    return new Error(
        "Takipten çıkardığınız taraflar şu alacak kalemlerinin tek tarafı: " +
        kalemAdlari.join(", ") +
        ". Bu kalemler tarafsız kalacağı için takip açılamaz; ilgili tarafı tekrar seçin ya da XML'i düzenleyin."
    );
}

/** Seçim sonrası listede hiç alacaklı ya da borçlu kalmıyorsa eksik rollerin adları. */
export function eksikRoller(tarafList: Array<TarafKisi | TarafKurum>): string[] {
    const eksik: string[] = [];
    if (!tarafList.some(taraf => taraf.isAlacakli()))
        eksik.push("alacaklı");
    if (!tarafList.some(taraf => taraf.isBorclu()))
        eksik.push("borçlu");
    return eksik;
}

/** Uygulama doğrulaması bunu zaten engeller; kuyruk görevi başka istemcide çalışsa da UYAP'a gitmesin. */
export function eksikRolHatasi(roller: string[]): Error {
    return new Error(
        "Takipten çıkardığınız taraflardan sonra dosyada hiç " + roller.join(" ve ") +
        " kalmıyor; takip açılamaz. En az bir " + roller.join(" ve bir ") + " seçin."
    );
}
